import type { ButtonIconVariant } from '@kanda-libs/ks-design-library';

export const BUTTON_PROPS = {
  id: 'account-settings-desktop-back',
  size: '48-20' as unknown as number,
  variant: 'ghost-grey' as ButtonIconVariant,
  icon: 'arrow-left',
};
